import {Directive, Input, HostListener, HostBinding, Component} from '@angular/core';
import { NavItemBaseComponent } from './_nav-item-base.component';


@Component({
  selector: '[navItem]',
  exportAs: 'nav-item-directive',
  template: '',
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class NavItemDirective extends NavItemBaseComponent {

  @HostBinding('class.nav-item') navItem: boolean = true;

  @HostBinding('class.active')
  @Input() active: boolean = false;

  @HostListener('click') onClick() {
    this.navService.selectNav(this);
  }

}
